module.exports = __webpack_public_path__ + "media/images/scoreBet__detailScore__markCorrect-a12b9028e1a31c6370273ae80cc54dd4.png";